<template>
  <div
    class="section-card"
    v-tooltip="active ? null : content[SectionCardId-1].tooltip"
    @click="$emit('click')"
  >
    <div class="circle" :class="{'active': active}">{{ SectionCardId }}</div>
    <div class="card-text">
      <div class="card-title" :class="{'active': active}">{{content[SectionCardId-1].title}}</div>
      <div class="card-detail" :class="{'active': active}">{{content[SectionCardId-1].detail}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionCard",
  components: {
  },
  props: {
    SectionCardId: String,
    active: Boolean,
    src: String
  },
  data: function() {
    return {
      content: this.$i18n.t("views.homeView"),
      toggleTooltip: false
    };
  }
};
</script>



<style lang="sass" scoped>
.section-card
  display: flex
  flex-direction: row
  align-items: center
  cursor: pointer

  .circle
    width: 30px
    height: 30px
    min-width: 30px
    border-radius: 50%
    background-color: #B5B5B5
    color: white
    font-weight: 700
    font-size: 0.923rem // 12px / 13px base
    display: flex
    align-items: center
    justify-content: center

    &.active
      background-color: #E85D2B

  .card-text
    margin-left: 10px

    .card-title
      font-weight: 700
      font-size: 1.385rem // 18px / 13px base
      color: #B5B5B5
      margin: 0
      padding: 0
      line-height: 1.2

      &.active
        color: #E85D2B

    .card-detail
      font-weight: 400
      font-size: 1.231rem // 16px / 13px base
      color: #B5B5B5
      margin: 0
      line-height: 1.3

      &.active
        color: #E85D2B

</style>
